module.exports = __webpack_public_path__ + "img/headon_logo_150x40_tp.45ebc9c4.png";